import {SecureService} from "@/services/superclasses/secure-service";
import {Industry} from "@/interfaces/industry";

const api = window.contextPath + '/rest/industries';

export class IndustrySecureService extends SecureService {

    public loadByMember = async (): Promise<Industry[]> => {
        return this.data(await this.get<Industry[]>(api + "/by-member"))
    }
}

export const industrySecureService = new IndustrySecureService()